"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatoCertificazioneTypeToJSON = exports.StatoCertificazioneTypeFromJSONTyped = exports.StatoCertificazioneTypeFromJSON = exports.StatoCertificazioneType = void 0;
/**
 *
 *
 * 1 = Inserita
 *
 * 2 = Invalidata
 *
 * 3 = Scaduta
 *
 * 4 = Inviata
 *
 * 5 = Certificata
 *
 * 6 = InviataPreview
 * @export
 * @enum {string}
 */
var StatoCertificazioneType;
(function (StatoCertificazioneType) {
    StatoCertificazioneType[StatoCertificazioneType["NUMBER_1"] = 1] = "NUMBER_1";
    StatoCertificazioneType[StatoCertificazioneType["NUMBER_2"] = 2] = "NUMBER_2";
    StatoCertificazioneType[StatoCertificazioneType["NUMBER_3"] = 3] = "NUMBER_3";
    StatoCertificazioneType[StatoCertificazioneType["NUMBER_4"] = 4] = "NUMBER_4";
    StatoCertificazioneType[StatoCertificazioneType["NUMBER_5"] = 5] = "NUMBER_5";
    StatoCertificazioneType[StatoCertificazioneType["NUMBER_6"] = 6] = "NUMBER_6";
})(StatoCertificazioneType = exports.StatoCertificazioneType || (exports.StatoCertificazioneType = {}));
function StatoCertificazioneTypeFromJSON(json) {
    return StatoCertificazioneTypeFromJSONTyped(json, false);
}
exports.StatoCertificazioneTypeFromJSON = StatoCertificazioneTypeFromJSON;
function StatoCertificazioneTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.StatoCertificazioneTypeFromJSONTyped = StatoCertificazioneTypeFromJSONTyped;
function StatoCertificazioneTypeToJSON(value) {
    return value;
}
exports.StatoCertificazioneTypeToJSON = StatoCertificazioneTypeToJSON;
